import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from "../../app.component";

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./create-account.component.less']
})
export class CreateAccountComponent implements OnInit {
  global_texts: any = null;

  constructor(
    public app: AppComponent,
  ) {  }

  ngOnInit(): void {
    // Get the global texts
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      this.global_texts = texts;
    });
  }
}
